export const getDefaultApiUrl = (): string => process.env.REACT_APP_HELIX_API_URL as string;
